<div class="{{teaserClass}} fernwaerme-teaser grid-x">
  @if (showBadge && !showLogo) {
      <i class="icon-badge_check"></i>
  }
  @if (showLogo && logoPath) {
    <img class="portal-logo" [src]="logoPath" alt="{{textkeyPrefix + teaserTopic + '.alttext' | translate}}">
  }
  <div class="cell medium-{{imagePath ? 'auto' : 12}} medium-order-2">
    <h3 class="cell medium-order-2 medium-8" [innerHTML]="textkeyPrefix + teaserTopic + '.headline' + textkeyPostfix | translate"></h3>
    <p [innerHTML]="textkeyPrefix + teaserTopic + '.description' + textkeyPostfix | translate"></p>
    <p class="teaser" [innerHTML]="textkeyPrefix + teaserTopic + '.teaser' + textkeyPostfix | translate"></p>
  </div>
  @if (imagePath) {
    <div class="cell show-for-medium medium-shrink medium-order-1 img">
      <img [src]="imagePath" [alt]="textkeyPrefix + teaserTopic + '.alttext' | translate">
    </div>
  }
  <a role="button" class="button {{buttonClass}} {{isInternalPortal ? 'signal2' : 'primary'}} cell medium-order-3" [href]="(textkeyPrefix + teaserTopic + '.button.link') | translate" target="_blank" rel="noopener noreferrer">
    @if (downloadIcon) {
      <i class="icon-download" [attr.aria-label]="'arialabel.download.icon' | translate"></i>
    }
    <span [innerHTML]="textkeyPrefix + teaserTopic + '.button' + textkeyPostfix | translate"></span>
  </a>
</div>
